import React, { useEffect, useState } from "react";
import RootLayout from "../../../layout/layout";
import Pagination from "../../../components/table/pagination/Pagination";
import { getTotalNumberOfUsers, getUsers } from "../../api/services";
import { Player } from "../../../types/User";

const UserPage = () => {
  const [users, setUsers] = useState<Player[]>([]);
  const [lastUserId, setLastUserId] = useState("");
  const [prevUserId, setPrevUserId] = useState("");
  const [userIdArr, setUserIdArr] = useState<string[]>([]);
  const [numberOfUsers, setNumberOfUsers] = useState(0);
  const [loading, setLoading] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    getTotalNumberOfUsers().then((data) => {
      setNumberOfUsers(data.totalUserCount);
    });
  }, []);

  useEffect(() => {
    getUsers().then((data) => {
      setLastUserId(data.nextPageLastUserId);
      setUserIdArr([data.nextPageLastUserId]);
      setUsers(data.players);
    });
  }, []);

  const handleNextClick = () => {
    let idArr = [...userIdArr];
    setLoading(1);
    getUsers(lastUserId).then((data) => {
      setLastUserId(data.nextPageLastUserId);
      const present = idArr.filter((id) => id === data.nextPageLastUserId);
      present.length === 0 && idArr.push(data.nextPageLastUserId);
      setPrevUserId(lastUserId);
      setUserIdArr(idArr);
      setUsers(data.players);
      setPageNumber(pageNumber + 1);
      setLoading(0);
    });
  };

  const handlePrevClick = () => {
    if (pageNumber > 1) {
      setLoading(1);
      getUsers(userIdArr[pageNumber - 3]).then((data) => {
        setLastUserId(data.nextPageLastUserId);
        setPrevUserId(data.lastUserId);
        setUsers(data.players);
        setLoading(0);
        setPageNumber(pageNumber - 1);
      });
    }
  };

  return (
    <RootLayout title="Users Manager">
      <div className="p-5 overflow-auto h-full">
        <section className="bg-white h-20 w-40 rounded-lg p-2">
          <div className="flex gap-2">
            <div className="bg-gray-500 w-4 h-4 rounded-full mt-1" />
            <div className="text-gray-500 flex items-center flex-col">
              <div className="font-semibold">Total Users</div>
              <div className="font-bold text-3xl">{numberOfUsers}</div>
            </div>
          </div>
        </section>
        <div className="relative overflow-x-auto pt-4">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3">
                  USERNAME
                </th>
                <th scope="col" className="px-6 py-3">
                  PHONE
                </th>
              </tr>
            </thead>
            <tbody>
              {users?.map((user) => (
                <tr
                  className="bg-white border-b-4 border-gray-200"
                  key={user.user_id}
                >
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                  >
                    {user.user_name}
                  </th>
                  <td className="px-6 py-4">{user.user_phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            onNextClick={() => {
              handleNextClick();
            }}
            onPrevClick={() => {
              handlePrevClick();
            }}
          />
        </div>
      </div>
    </RootLayout>
  );
};

export default UserPage;
